<!-- patient-measure-details.component.html -->
<div class="patient-measure-table-container">

  <table mat-table [dataSource]="filteredPatients" matSort class="patient-measures-table">
    <!-- Measure Column -->
    <ng-container matColumnDef="measureName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Measure</th>
      <td mat-cell *matCellDef="let patient">{{ patient.measureName }}</td>
    </ng-container>

    <ng-container matColumnDef="providerName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Provider</th>
      <td mat-cell *matCellDef="let patient">{{ patient.providerName }}</td>
    </ng-container>

    <!-- Location Column -->
    <ng-container matColumnDef="location">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Location</th>
      <td mat-cell *matCellDef="let patient">{{ patient.location }}</td>
    </ng-container>

    <!-- Patient ID Column -->
    <ng-container matColumnDef="patientID">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Pat ID</th>
      <td mat-cell *matCellDef="let patient">{{ patient.patientID }}</td>
    </ng-container>

    <!-- First Name Column -->
    <ng-container matColumnDef="firstName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>First Name</th>
      <td mat-cell *matCellDef="let patient">{{ patient.firstName }}</td>
    </ng-container>

    <!-- Last Name Column -->
    <ng-container matColumnDef="lastName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Last Name</th>
      <td mat-cell *matCellDef="let patient">{{ patient.lastName }}</td>
    </ng-container>

    <!-- Race Column -->
    <ng-container matColumnDef="race">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Race</th>
      <td mat-cell *matCellDef="let patient">{{ patient.race }}</td>
    </ng-container>

    <!-- Gender Column -->
    <ng-container matColumnDef="gender">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Gender</th>
      <td mat-cell *matCellDef="let patient">{{ patient.gender }}</td>
    </ng-container>

    <!-- Age Column -->
    <ng-container matColumnDef="age">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Age</th>
      <td mat-cell *matCellDef="let patient">{{ patient.age }}</td>
    </ng-container>

    <!-- Encounter Date Column -->
    <ng-container matColumnDef="encounterDate">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Encounter Date</th>
      <td mat-cell *matCellDef="let patient">{{ patient.encounterDate  | date:'MM/dd/yyyy'}}</td>
    </ng-container>

    <!-- Denominator Column -->
    <ng-container matColumnDef="den">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Den</th>
      <td mat-cell *matCellDef="let patient">{{ patient.den }}</td>
    </ng-container>

    <ng-container matColumnDef="denExcl">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Den Excl</th>
      <td mat-cell *matCellDef="let patient">{{ patient.denExcl }}</td>
    </ng-container>

    <!-- Numerator Column -->
    <ng-container matColumnDef="num">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Num</th>
      <td mat-cell *matCellDef="let patient">{{ patient.num }}</td>
    </ng-container>

    <!-- Diagnosis Code Column -->
    <ng-container matColumnDef="diagCode">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Diag</th>
      <td mat-cell *matCellDef="let patient">{{ patient.diagCode }}</td>
    </ng-container>

    <!-- Diagnosis Description Column -->
    <ng-container matColumnDef="diagDesc">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Diag Desc</th>
      <td mat-cell *matCellDef="let patient">{{ patient.diagDesc }}</td>
    </ng-container>

    <!-- Procedure Column -->
    <ng-container matColumnDef="procedure">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Procedure</th>
      <td mat-cell  *matCellDef="let patient">{{ patient.procedureCode }}</td>
    </ng-container>

    <!-- Procedure Date Column -->
    <ng-container matColumnDef="procedureDate">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Procedure Date</th>
      <td mat-cell *matCellDef="let patient">{{ patient.procedureDate | date:'MM/dd/yyyy'}}</td>
    </ng-container>

       <!-- Medication Column -->
       <ng-container matColumnDef="medication">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Medication</th>
        <td mat-cell *matCellDef="let patient">{{ patient.medication }}</td>
      </ng-container>
  
      <!-- Medication Date Column -->
      <ng-container matColumnDef="medicationDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Medication Date</th>
        <td mat-cell *matCellDef="let patient">{{ patient.medicationDate | date:'MM/dd/yyyy'}}</td>
      </ng-container>

    <!-- Actions Column -->
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let patient">
        <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Actions">
          <mat-icon [ngClass]="{ 'validated-icon': patient.validated }">
            {{ patient.validated ? 'check_circle' : 'more_vert' }}
          </mat-icon>
        </button>
       
        <mat-menu #menu="matMenu">
          <button mat-menu-item (click)="createTicket(patient)">
            <mat-icon>create</mat-icon>
            <span>Create Ticket</span>
          </button>
          <button mat-menu-item (click)="validatePatient(patient)">
            <mat-icon>check_circle</mat-icon>
            <span>Validate Patient</span>
          </button>
        </mat-menu>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <!-- Make sure paginator is properly configured -->
  <mat-paginator [pageSizeOptions]="[5, 10, 25, 50, 100]" 
                 showFirstLastButtons 
                 aria-label="Select page of patients">
  </mat-paginator>
</div>
